"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ScatterRenderable = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var defaultDot = function defaultDot(props) {
  return _react.default.createElement("circle", (0, _extends2.default)({
    fill: "black",
    r: 3
  }, props.dotProps));
};

var isNumber = function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
};

var ScatterRenderable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ScatterRenderable, _React$PureComponent);

  function ScatterRenderable(props) {
    (0, _classCallCheck2.default)(this, ScatterRenderable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ScatterRenderable).call(this, props));
  }

  (0, _createClass2.default)(ScatterRenderable, [{
    key: "buildDot",
    value: function buildDot(row, index) {
      if (!isNumber(row.x) || !isNumber(row.y)) return null;
      var _this$props = this.props,
          Dot = _this$props.dot,
          dotProps = _this$props.dotProps;
      return _react.default.createElement(Dot, {
        key: index,
        dotProps: (0, _objectSpread2.default)({
          cx: row.x,
          cy: row.y
        }, dotProps),
        dimensions: row,
        index: index,
        data: this.props.data,
        scaledData: this.props.scaledData
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement("g", null, this.props.scaledData.map(function (row, index) {
        return _this.buildDot(row, index);
      }));
    }
  }]);
  return ScatterRenderable;
}(_react.default.PureComponent);

exports.ScatterRenderable = ScatterRenderable;
(0, _defineProperty2.default)(ScatterRenderable, "defaultProps", {
  dot: defaultDot
});
(0, _defineProperty2.default)(ScatterRenderable, "propTypes", {
  data: _propTypes.default.object,
  scaledData: _propTypes.default.arrayOf(_propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  })).isRequired,
  dotProps: _propTypes.default.object,
  dot: _propTypes.default.func
});

var Scatter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Scatter, _React$Component);

  function Scatter() {
    (0, _classCallCheck2.default)(this, Scatter);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Scatter).apply(this, arguments));
  }

  (0, _createClass2.default)(Scatter, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(ScatterRenderable, this.props);
    }
  }]);
  return Scatter;
}(_react.default.Component);

exports.default = Scatter;
(0, _defineProperty2.default)(Scatter, "chartType", 'canvas');
(0, _defineProperty2.default)(Scatter, "propTypes", {
  dotProps: _propTypes.default.object,
  dot: _propTypes.default.func
});